<!-- <!DOCTYPE html>
<html lang="en" xml:lang="en">
  <head>
    <title>Error</title>
  </head>
  <body>
    <div>
      <div class="error-container">
        <h1>Oops!</h1>
        <h2>422 Unauthorised</h2>
        <div class="error-message" style="color: #000">
          Sorry, Malform Found!
        </div>
        <div>
          <a
            href="login"
            class="btn btn btn-lg"
            style="background-color: #21293a; color: #ffffff"
            >BACK</a
          >
          <a href="login" class="btn btn btn-lg">Contact Support</a>
        </div>
      </div>
    </div>
  </body>
</html> -->


<!DOCTYPE html>
<html lang="en" xml:lang="en">
  <head>
    <title>Error 404</title>
  </head>
  <body>
    <div>
      <div class="error-container">
        <h1>Oops!</h1>
        <h2>422 Unauthorised</h2>
        <div class="error-message" style="color: #ffffff;
        font-size: 12px;
        padding-bottom: 2em;">
         Sorry, Malform Found!
        </div>
        <div>
          <a
            href="login"
            class="btn btn btn-lg"
            style="background-color: #FFD958;
            color: #000;
            font-size: 12px;
            font-weight: 500;
            border-radius: 5px;"
            >BACK</a
          >
          <a href="login" class="btn btn btn-lg" style="font-size: 12px; color: #fff;">Contact Support</a>
        </div>
      </div>
    </div>
  </body>
</html>
